import Typography from '@components/v2/ui/Typography/Typography';
import { Stack } from '@mui/material';
import LangEnum from '../../../../../lang/LangEnum';
import { useTranslation } from '../../../../translation/TranslationContext';
import SettingContainer from '../../../SettingContainer';
import { OrderAbandonmentSectionGeneralSettingsProps } from '../../types/GeneralSettings.types';
import InactivityBlockConfig from './components/InactivityBlockConfig';
import { INACTIVITY_CONFIGS, REFERENCE_DATE_ITEMS } from './utils/orderInactivity.consts';

const OrderInactivitySectionGeneralSettings = ({
  generalSettings,
  handleBlur,
  handleChangeAndBlur,
  handleChange,
}: OrderAbandonmentSectionGeneralSettingsProps) => {
  const { translate } = useTranslation();

  const referenceDateItems = REFERENCE_DATE_ITEMS.map(({ description, label, value }) => ({
    label: translate(label),
    description: translate(description),
    value,
  }));

  return (
    <SettingContainer
      title={translate(LangEnum.GENERAL_SETTINGS_ORDER_INACTIVITY_TITLE)}
      renderInfo={() => (
        <Stack>
          <Typography gutterBottom color="textSecondary">
            {translate(LangEnum.GENERAL_SETTINGS_ORDER_INACTIVITY_DESCRIPTION)}
          </Typography>
          <Typography color="textSecondary" variant="body1">
            {translate(LangEnum.GENERAL_SETTINGS_ORDER_INACTIVITY_DESCRIPTION_ATTENTION)}
          </Typography>
        </Stack>
      )}
    >
      <Stack spacing={4}>
        {INACTIVITY_CONFIGS.map(({ keys, labels }) => (
          <InactivityBlockConfig
            key={`${String(keys.selectName)}-${String(keys.timeoutName)}`}
            items={referenceDateItems}
            generalSettings={generalSettings}
            handleChangeAndBlur={handleChangeAndBlur}
            handleChange={handleChange}
            handleBlur={handleBlur}
            keys={keys}
            labels={{
              inputLabel: translate(labels.inputLabel as LangEnum),
              selectLabel: translate(labels.selectLabel as LangEnum),
            }}
          />
        ))}
      </Stack>
    </SettingContainer>
  );
};

export default OrderInactivitySectionGeneralSettings;
